import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { collection, doc, getDoc } from 'firebase/firestore';
import { firestore } from '../firebase';
import './PendingApprovalScreen.css';

export default function PendingApprovalScreen() {
    const [userInfo, setUserInfo] = useState(null);
    const [companyDetails, setCompanyDetails] = useState(null);
    const history = useHistory();

    useEffect(() => {
        // Get pending user info from localStorage
        const pendingUser = localStorage.getItem('pendingUserInfo');
        if (pendingUser) {
            setUserInfo(JSON.parse(pendingUser));
        } else {
            // Redirect to signin if no pending user data
            history.push('/signin');
        }

        // Fetch company details for support contact
        fetchCompanyDetails();
    }, [history]);

    const fetchCompanyDetails = async () => {
        try {
            const COMPANY_DOC_ID = '63qcu0OcfuZT9kOiRuNw';
            // Try the provided doc id first
            let companySnap = await getDoc(doc(firestore, "COMPANY DETAILS", COMPANY_DOC_ID));
            if (!companySnap.exists()) {
                // Fallback to legacy 'info' doc id
                companySnap = await getDoc(doc(firestore, "COMPANY DETAILS", "info"));
            }
            if (companySnap.exists()) setCompanyDetails(companySnap.data());
        } catch (error) {
            console.error('Error fetching company details:', error);
        }
    };

    const handleBackToSignin = () => {
        localStorage.removeItem('pendingUserInfo');
        // Prevent SignIn screen from immediately redirecting back here if error still in store
        try { sessionStorage.setItem('ignorePendingOnce', '1'); } catch (_) {}
        history.push('/signin');
        // Ensure we land at the top of the Sign In page
        setTimeout(() => {
            try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (_) {}
        }, 0);
    };

    const handleContactSupport = () => {
        if (companyDetails && companyDetails.supportPhone) {
            window.open(`tel:${companyDetails.supportPhone}`);
        }
    };

    if (!userInfo) {
        return <div>Loading...</div>;
    }

    return (
        <div className="pending-approval-screen">
            <div className="pending-container">
                <div className="pending-card">
                    <div className="pending-header">
                        <div className="status-icon">⏳</div>
                        <h1>Account Pending Approval</h1>
                        <p>Your registration is under review</p>
                    </div>

                    <div className="pending-content">
                        <div className="user-info-section">
                            <h3>Account Details</h3>
                            <div className="info-grid">
                                <div className="info-item">
                                    <label>Account Type:</label>
                                    <span className={`role-badge ${userInfo.Role}`}>
                                        {userInfo.Role === 'retailer' ? '🏪 Retailer' : '👤 User'}
                                    </span>
                                </div>
                                <div className="info-item">
                                    <label>Name:</label>
                                    <span>{userInfo.Full_Name}</span>
                                </div>
                                <div className="info-item">
                                    <label>Email:</label>
                                    <span>{userInfo.Email}</span>
                                </div>
                                <div className="info-item">
                                    <label>Mobile:</label>
                                    <span>{userInfo.Mobile_No}</span>
                                </div>
                                {userInfo.Role === 'retailer' && (
                                    <>
                                        <div className="info-item">
                                            <label>Company:</label>
                                            <span>{userInfo.Shop_Name}</span>
                                        </div>
                                        <div className="info-item">
                                            <label>Document Type:</label>
                                            <span>{userInfo.Business_Proof_Type}</span>
                                        </div>
                                        <div className="info-item">
                                            <label>Document Number:</label>
                                            <span>{userInfo.Business_Proof_No}</span>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        <div className="status-section">
                            <div className="status-message">
                                <h3>What happens next?</h3>
                                {userInfo.Role === 'retailer' ? (
                                    <div className="steps">
                                        <div className="step">
                                            <span className="step-number">1</span>
                                            <div className="step-content">
                                                <strong>Document Verification</strong>
                                                <p>Our team is reviewing your business documents</p>
                                            </div>
                                        </div>
                                        <div className="step">
                                            <span className="step-number">2</span>
                                            <div className="step-content">
                                                <strong>Business Verification</strong>
                                                <p>We may contact you for additional information</p>
                                            </div>
                                        </div>
                                        <div className="step">
                                            <span className="step-number">3</span>
                                            <div className="step-content">
                                                <strong>Account Activation</strong>
                                                <p>You'll receive an email once approved</p>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <p>Your account is being reviewed by our team. This usually takes 1-2 business days.</p>
                                )}
                            </div>
                        </div>

                        <div className="contact-section">
                            <h3>Need Help?</h3>
                            <p>If you have any questions or need assistance, please contact our support team.</p>

                            <div className="contact-options">
                                

                               

                                {/* Support Email */}
                                <div className="support-row">
                                    <strong>Email:</strong>&nbsp;
                                    <a 
                                        href={`mailto:${companyDetails?.supportEmail || 'support@shopiebazar.com'}`}
                                        className="contact-inline email"
                                    >
                                        {companyDetails?.supportEmail || 'support@shopiebazar.com'}
                                    </a>
                                </div>

                                {/* Support Phone (plain text, normalized with +91-) */}
                                <div className="support-row">
                                    <strong>Phone:</strong>&nbsp;
                                    <span>
                                        {(() => {
                                            const p = companyDetails?.supportPhone;
                                            if (!p) return '+91-XXXXXXXXXX';
                                            const s = String(p).trim();
                                            if (s.startsWith('+')) return s;
                                            const d = s.replace(/[^0-9]/g, '');
                                            if (d.length === 10) return `+91-${d}`;
                                            if (d.length === 12 && d.startsWith('91')) return `+${d.slice(0,2)}-${d.slice(2)}`;
                                            return s;
                                        })()}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="action-section">
                            <button 
                                className="back-btn"
                                onClick={handleBackToSignin}
                            >
                                Back to Sign In
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
